module.exports = __webpack_public_path__ + "img/mono_17.cb834a7b.png";